import { useState } from "react";

/**
 * Like useState, but it remembers its value by storing it in localStorage.
 * Useful if you want a state variable that survives its component being unmounted and re-mounted.
 * Used for recording the filters a user sets on order-history etc.
 *
 * Because it is putting stuff into localStorage, do NOT use it for anything secure that you wouldn't
 * want the world to see.
 *
 * @param storageId -- the name of the item to record in localStorage
 * @param dflt -- the dedfault value to if one does not exist in localStorage
 */
const usePersistentState = (storageId: string, dflt: any) => {
  const defaultString = localStorage.getItem(storageId);
  const defaultValue = defaultString ? JSON.parse(defaultString) : null;

  const [val, setVal] = useState(defaultValue || dflt);

  return [
    val,
    (x: any) => {
      localStorage.setItem(storageId, JSON.stringify(x));
      setVal(x);
    }
  ];
};

export default usePersistentState;
